import { combineReducers } from 'redux'

import language from './slices/language'

const rootReducer = combineReducers({
  language
})

export default rootReducer
